<div class="d-flex">

  <app-tabs-form [activeFormTab]="activeFormTab" [draft]="draft" (changeForm)="changeForm($event)"
    [updatesTabs]="updatesTabs" [document_buttons_chico]="document_buttons_chico"></app-tabs-form>

  <div class="card w-100 form-right">
    <div class="back">
      <h2 class="edit-client">
        {{ "forms.names.editClient" | translate }} {{clientData?.name}}
      </h2>
      <i class="icon-cross2" (click)="emitBackButtonClick()"></i>
    </div>
    <div class="card-body">

      <div class="row">
        <div class="form">

          <form [formGroup]="form">
            <div class="form-section mb-3 pb-3" *ngIf="activeFormTab == 'general'">
              <div class="input-group justify-content-end">
                <div class="clear">
                  <button *ngIf="clientData?.assignee" class="btn btn-hover clear-button  ml-15" type="button"
                    (click)="openAssigneeForm()">
                    {{"inputs.see_assignee" | translate }} {{clientData.client?.assignee.name}} <i
                      class="icon-chevron-right"></i>
                  </button>
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-12">
                  <div class="mb-3">
                    <label for="tax_id" class="form-label">{{ "inputs.tax_id" | translate
                      }}<span class="required">*</span></label>
                    <input id="tax_id" class="form-control" formControlName="tax_id"
                      placeholder="{{ 'inputs.tax_id' | translate }}" />
                  </div>
                </div>
              </div>

              <!-- <div class="row mb-2">
                <div class="col-12">
                  <div class="mb-3">
                    <label for="type" class="form-label">{{ "inputs.type" | translate }}
                      <span class="required">*</span>
                    </label>
                    <div class="position-relative">
                      <select id="type" class="form-control" formControlName="type">
                        <option *ngIf="canShowClientType('organization')" value="organization">
                          {{ "inputs.organization" | translate }}
                        </option>
                        <option *ngIf="canShowClientType('individual')" value="individual">
                          {{ "inputs.individual" | translate }}
                        </option>
                        <option *ngIf="canShowClientType('self-employed')" value="self-employed">
                          {{ "inputs.self-employed" | translate }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div> -->

              <div class="row mb-2">
                <div class="col-12">
                  <div class="mb-3">
                    <label for="type" class="form-label">{{ "inputs.type" | translate }}
                      <span class="required">*</span>
                    </label>
                    <div class="position-relative">
                      <div class="input-group">
                      <select id="type" class="form-control" formControlName="type">
                        <option value="" disabled selected>{{ "inputs.select_option" | translate }}</option>
                        <option *ngFor="let type of types" [value]="type.reference">
                          {{ "inputs." + type.reference | translate }}
                        </option>
                      </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row linea"></div>

              <div class="row mb-2" *ngIf="type !== 'organization'">
                <div class="col-12 col-xl-6">
                  <div class="mb-3">
                    <label for="name" class="form-label">{{ "inputs.name" | translate
                      }}<span class="required">*</span></label>
                    <input id="name" class="form-control" formControlName="name"
                      placeholder="{{ 'inputs.name' | translate }}" />
                  </div>
                </div>

                <div class="col-12 col-xl-6">
                  <div class="mb-3">
                    <label for="lastname" class="form-label">{{
                      "inputs.lastname" | translate
                      }}</label>
                    <input id="lastname" class="form-control" formControlName="lastname"
                      placeholder="{{ 'inputs.lastname' | translate }}" />
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="type === 'organization'">
                <div class="col-12">
                  <div class="mb-3">
                    <label for="name" class="form-label">{{ "inputs.name" | translate
                      }}<span class="required">*</span></label>
                    <input id="name" class="form-control" formControlName="name"
                      placeholder="{{ 'inputs.name' | translate }}" />
                  </div>
                </div>
              </div>

              <div class="row linea" *ngIf="type !== 'organization'"></div>

              <div class="row mb-2" *ngIf="type !== 'organization'">
                <div class="col-12">
                  <div class="mb-3">
                    <label for="birth_date" class="form-label">{{ "inputs.birth_date" | translate }}</label>
                    <mat-form-field appearance="fill">
                      <input matInput [matDatepicker]="birthDatepicker" formControlName="birth_date"
                        placeholder="{{ 'inputs.birth_date' | translate }}" (dateChange)="onDateChange($event)"
                        [min]="minDate" [max]="maxDate">

                      <mat-datepicker-toggle matSuffix [for]="birthDatepicker"></mat-datepicker-toggle>
                      <mat-datepicker #birthDatepicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col-5 col-xl-4">
                    <div class="mb-3">
                      <label for="vendor" class="form-label">{{ "inputs.birthplace_country" | translate }}
                      </label>
                      <app-select-country-prefix [showPhonePrefix]="false" [selectionMode]="'name'"
                        [selectedCountryName]="form.get('birthplace_country')?.value"
                        (changeBirthplace)="changeBirthplace($event)"
                        (countrySelected)="onBirthplaceCountrySelected($event)">
                      </app-select-country-prefix>
                    </div>
                  </div>
                  <div class="col-7 col-xl-8">
                    <div class="mb-3">
                      <label for="supplier" class="form-label">{{ "inputs.nationality" | translate }}</label>
                      <input id="lastname" class="form-control" formControlName="nationality"
                        placeholder=' {{ "inputs.nationality" | translate }}' />
                    </div>
                  </div>
                </div>
              </div>

              <div class="row linea"></div>

              <div class="row mb-2" *ngIf="type !== 'organization'">

                <div class="col-12 col-xl-6">
                  <div class="mb-3">
                    <label for="document_issue_date" class="form-label">{{'inputs.document_issue_date' |
                      translate }}
                    </label>
                    <mat-form-field appearance="fill">
                      <input matInput [matDatepicker]="documentIssueDatepicker"
                        formControlName="document_issue_date"
                        placeholder="{{'inputs.document_issue_date' | translate }}"
                        (dateChange)="onDateChange2($event)" [min]="minDate" [max]="maxDate">

                      <mat-datepicker-toggle matSuffix [for]="documentIssueDatepicker"></mat-datepicker-toggle>
                      <mat-datepicker #documentIssueDatepicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-12 col-xl-6">
                  <div class="mb-3">
                    <label for="document_expiration_date" class="form-label">{{'inputs.tax_id_expiration_date' |
                      translate }}
                    </label>
                    <mat-form-field appearance="fill">
                      <input matInput [matDatepicker]="documentExpirationDatepicker"
                        formControlName="document_expiration_date"
                        placeholder="{{'inputs.tax_id_expiration_date' | translate }}"
                        (dateChange)="onDateChange2($event)" [min]="minDate" [max]="maxDateExpiration">

                      <mat-datepicker-toggle matSuffix [for]="documentExpirationDatepicker"></mat-datepicker-toggle>
                      <mat-datepicker #documentExpirationDatepicker></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12" *ngIf="type === 'organization'">
                  <div class="mb-3">
                    <label for="client" class="form-label">{{ "inputs.associateClient" | translate }}
                      <span class="required">*</span><span class="info"><a (click)="verAssignee()"> ({{
                          "inputs.viewAssociate" | translate }})</a></span>
                    </label>
                    <ng-select [items]="filteredClients" bindLabel="displayName" class="select-client-associated"
                      bindValue="reference" formControlName="assignee_id" [searchable]="true" placeholder="{{
                        'inputs.associateClient' | translate
                      }}" [clearable]="true" [class.has-value]="form.get('assignee_id')?.value">
                    </ng-select>
                  </div>
                </div>
              </div>

              <div class="row linea"></div>

              <div class="row mb-2">
                <div class="mb-3">
                  <label for="email" class="form-label">{{ "inputs.email" | translate
                    }}<span class="required">*</span></label>
                  <input id="email" class="form-control" formControlName="email"
                    placeholder="{{ 'inputs.email' | translate }}" />
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-4">
                  <div class="mb-3">
                    <label for="phone_prefix" class="form-label">{{ "inputs.phone_prefix" | translate }}
                      <span class="required">*</span>
                    </label>
                    <app-select-country-prefix (changePrefix)="changePrefix($event)"
                      [selectedPrefix]="form.get('phonePrefix')?.value" [selectionMode]="'prefix'">
                    </app-select-country-prefix>
                  </div>
                </div>
                <div class="col-8">
                  <div class="mb-3">
                    <label for="phone" class="form-label">{{ "inputs.phone" | translate }}
                      <span class="required">*</span>
                    </label>
                    <input id="phone" class="form-control phone-number" formControlName="phoneNumber" type="tel"
                      placeholder="{{ 'inputs.phone' | translate }}" (input)="onInput($event)" />
                  </div>
                  <div *ngIf="form.hasError('invalidPhoneNumber') && form.get('phoneNumber')?.touched">
                    <small class="error_validation">Si el prefijo es +34, el número debe tener 9 dígitos.</small>
                  </div>
                  <div *ngIf="isFieldInvalid('phoneNumber')">
                    <small class="error_validation">El teléfono debe tener 9 dígitos, o si empieza con +34, debe tener 9
                      dígitos adicionales.</small>
                  </div>
                </div>
              </div>

              <div class="row linea"></div>

              <div class="row">
                <div class="col-12 col-xl-6">
                  <div class="mb-3">
                    <label for="billing_address" class="form-label">{{
                      "inputs.billing_address" | translate
                      }}</label>
                    <input id="billing_address" class="form-control" formControlName="billing_address" placeholder="{{
                        'inputs.billing_address' | translate
                      }}" />
                  </div>
                </div>
                <div class="col-12 col-xl-6">
                  <div class="mb-3">
                    <label for="billing_state" class="form-label">{{
                      "inputs.billing_state" | translate
                      }}</label>
                    <input id="billing_state" class="form-control" formControlName="billing_state" placeholder="{{
                        'inputs.billing_state' | translate
                      }}" />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-5 col-xl-6">
                  <div class="mb-3">
                    <label for="name" class="form-label">{{
                      "inputs.billing_postal_code" | translate
                      }}<span class="required">*</span></label>
                    <input id="name" class="form-control" formControlName="billing_postal_code" maxLength="5"
                      placeholder="{{ 'inputs.billing_postal_code' | translate }}"
                      (input)="onPostalCodeInput($event)" />
                  </div>
                  <div *ngIf="isFieldInvalid('billing_postal_code')">
                    <small *ngIf="getFormError('billing_postal_code', 'required')" class="error_validation">
                      El código postal es obligatorio.
                    </small>
                  </div>
                  <div *ngIf="form.hasError('invalidSpanishPostalCode') && form.get('billing_postal_code')?.touched">
                    <small class="error_validation">
                      Para España, el código postal debe tener exactamente 5 dígitos.
                    </small>
                  </div>
                  <div *ngIf="form.hasError('invalidPostalCode') && form.get('billing_postal_code')?.touched">
                    <small class="error_validation">
                      El código postal debe tener entre 4 y 5 dígitos.
                    </small>
                  </div>
                </div>
                <div class="col-7 col-xl-6">
                  <div class="mb-3">
                    <label for="lastname" class="form-label">{{
                      "inputs.billing_city" | translate
                      }}</label>
                    <input id="lastname" class="form-control" formControlName="billing_city" placeholder="{{
                        'inputs.billing_city' | translate
                      }}" />
                  </div>
                </div>
              </div>

              <div class="row linea" *ngIf="form.get('type')?.value !== 'organization'"></div>

              <div class="row mb-2" *ngIf="form.get('type')?.value !== 'organization'">
                <div class="col-12">
                  <div class="mb-3">
                    <label for="driver_license_issue_date" class="form-label">{{'inputs.driver_license_issue_date' |
                      translate }}
                    </label>
                    <mat-form-field appearance="fill">
                      <input matInput [matDatepicker]="driverLicenseDate" formControlName="driver_license_issue_date"
                        placeholder="{{'inputs.driver_license_issue_date' | translate }}"
                        (dateChange)="onDateChange3($event)" [min]="minDate" [max]="maxDate">

                      <mat-datepicker-toggle matSuffix [for]="driverLicenseDate"></mat-datepicker-toggle>
                      <mat-datepicker #driverLicenseDate></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              </div>

            </div>

            <!-- document  -->
            <div *ngIf="activeFormTab == 'client'">
              <app-form-add-document [clientData]="clientData" [activeForm]="'client'" [btn_submit]="true"
                (filesArrayChanged)="actualizarEstadoArchivos($event)"
                (formSubmit)="refreshClientData()"></app-form-add-document>
            </div>

            <div *ngIf="activeFormTab == 'financial-data'">
              <app-financial-data [client_reference]="clientData.reference" [clientData]="clientData"
                [client]="clientData" [activeFormTab]="activeFormTab"></app-financial-data>
            </div>

            <div *ngIf="activeFormTab == 'orders'">
              <app-form-clients-orders [client_reference]="clientData.reference" [clientData]="clientData"
                [activeFormTab]="activeFormTab" (closeOrderForm)="onOrderFormClosed()"
                (emitOpenOrderForm2)="openAddOrderForm2()" (backButtonClick2)="updateOrders()">
              </app-form-clients-orders>
            </div>
          </form>
        </div>
      </div>
      <div class="div-form mt-5"></div>
      <div class="btn-send" *ngIf="activeFormTab == 'general'">
        <button type="submit" class="btn btn-primary btn-primary-form" (click)="onSubmit()">
          {{ "buttons.update_client" | translate }}
        </button>
      </div>
    </div>
    <!-- end card body -->
  </div>
</div>
